import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import GallectionCover from '../GallectionCover';
import { ListItemCheckbox } from '@wix/da-ds/pkg/List/ListItem';
const GallectionListItemCheckbox = (_param)=>{
    var { gallection , onChange  } = _param, rest = _object_without_properties(_param, [
        "gallection",
        "onChange"
    ]);
    return /*#__PURE__*/ React.createElement(ListItemCheckbox, _extends({
        label: gallection.name,
        name: gallection.name,
        prefix: /*#__PURE__*/ React.createElement(GallectionCover, {
            gallection: gallection
        }),
        fillContainerWidth: true,
        onChange: (isSelectedNew)=>{
            onChange && onChange({
                folderId: gallection.folderId,
                isSelected: isSelectedNew
            });
        }
    }, rest));
};
GallectionListItemCheckbox.displayName = 'GallectionListItemCheckbox';
export default GallectionListItemCheckbox;
